export type TreeLevel<T> = {
  groupBy: (item: T) => string;
  getKey: (group: string, item: T) => string;
  getLabel: (item: T) => string;
};

export const buildTree = <T,>(data: T[], levels: TreeLevel<T>[]) => {
  const buildLevel = (items: T[], levelIndex: number): any[] => {
    if (levelIndex >= levels.length) return [];

    const level = levels[levelIndex];
    const map = new Map<string, any>();

    items.forEach((item) => {
      const group = level.groupBy(item);

      if (!map.has(group)) {
        map.set(group, {
          group,
          key: level.getKey(group, item),
          items: [],
          children: [],
          label: level.getLabel(item)
        });
      }

      map.get(group).items.push(item);
    });

    return Array.from(map.values()).map((node) => ({
      ...node,
      raw: node.items[0],
      children: buildLevel(node.items, levelIndex + 1)
    }));
  };

  return buildLevel(data, 0);
};
